export const SET_WIFI = 'GUIDE/WIFI/SET_WIFI'
export const SET_WIFIS = 'GUIDE/WIFI/SET_WIFIS'
